var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'MainGroupbuyingsList'
      }
    }
  }, [_vm._v("總公司團購管理 ")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.isEdit ? "編輯商品白名單" : "查看商品白名單") + " ")])], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('h4', {
    staticClass: "mb-2 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.isEdit ? "編輯商品白名單" : "查看商品白名單") + " ")]), _c('section', [_c('div', {
    staticClass: "col-12 col-xl-7 mb-4"
  }, [_c('ProductViewer', {
    staticClass: "mb-4",
    attrs: {
      "loading": _vm.isLoading,
      "product": _vm.product
    }
  })], 1), _vm.isLoading ? _c('div', [_c('b-skeleton', {
    staticClass: "mb-1",
    attrs: {
      "width": "85%"
    }
  }), _c('b-skeleton', {
    staticClass: "mb-1",
    attrs: {
      "width": "55%"
    }
  }), _c('b-skeleton', {
    staticClass: "mb-1",
    attrs: {
      "width": "70%"
    }
  })], 1) : _c('div', [_c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label": "商品編號",
      "label-for": "sale_page_code"
    }
  }, [_c('div', [_vm._v(" " + _vm._s(_vm.eventProduct.product && _vm.eventProduct.product.sale_page_code) + " ")])]), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label": "商品名稱",
      "label-for": "title"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.eventProduct.product && _vm.eventProduct.product.title))])]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "下拉選單起始日",
      "label-for": "start_at"
    }
  }, [_vm.isEdit ? _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "w-50"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "Select Date",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "disabledDates": _vm.disabledDates
    },
    model: {
      value: _vm.form.start_at.date,
      callback: function callback($$v) {
        _vm.$set(_vm.form.start_at, "date", $$v);
      },
      expression: "form.start_at.date"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.start_at.date.required.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('div', {
    staticClass: "ml-2 w-50"
  }, [_c('vue-timepicker', {
    attrs: {
      "format": "HH:mm",
      "input-class": ['form-control']
    },
    model: {
      value: _vm.form.start_at.time,
      callback: function callback($$v) {
        _vm.$set(_vm.form.start_at, "time", $$v);
      },
      expression: "form.start_at.time"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.start_at.time.HH.$error || !_vm.v$.form.start_at.time.mm.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1)]) : _c('div', [_vm._v(" " + _vm._s(_vm.eventProduct.start_at && _vm.format(new Date(_vm.eventProduct.start_at), "yyyy-MM-dd HH:mm")) + " ")])]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "下拉選單結束日",
      "label-for": "end_at"
    }
  }, [_vm.isEdit ? _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "w-50"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "Select Date",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "disabledDates": _vm.disabledDates
    },
    model: {
      value: _vm.form.end_at.date,
      callback: function callback($$v) {
        _vm.$set(_vm.form.end_at, "date", $$v);
      },
      expression: "form.end_at.date"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.end_at.date.required.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('div', {
    staticClass: "ml-2 w-50"
  }, [_c('vue-timepicker', {
    attrs: {
      "format": "HH:mm",
      "input-class": ['form-control']
    },
    model: {
      value: _vm.form.end_at.time,
      callback: function callback($$v) {
        _vm.$set(_vm.form.end_at, "time", $$v);
      },
      expression: "form.end_at.time"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.end_at.time.HH.$error || !_vm.v$.form.end_at.time.mm.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1)]) : _c('div', [_vm._v(" " + _vm._s(_vm.eventProduct.end_at && _vm.format(new Date(_vm.eventProduct.end_at), "yyyy-MM-dd HH:mm")) + " ")])]), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "每人最高購買數",
      "label-for": "once_max_quantity"
    }
  }, [_vm.isEdit ? [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "id": "once_max_quantity",
      "type": "number",
      "readonly": ""
    },
    model: {
      value: _vm.form.once_max_quantity,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "once_max_quantity", $$v);
      },
      expression: "form.once_max_quantity"
    }
  })] : _c('div', [_vm._v(" " + _vm._s(_vm.eventProduct.product && _vm.eventProduct.product.skus[0] && _vm.eventProduct.product.skus[0].once_max_quantity) + " ")])], 2), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "每人最低購買數",
      "label-for": "once_quantity"
    }
  }, [_vm.isEdit ? [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "id": "once_quantity",
      "type": "number",
      "readonly": ""
    },
    model: {
      value: _vm.form.once_quantity,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "once_quantity", $$v);
      },
      expression: "form.once_quantity"
    }
  })] : _c('div', [_vm._v(" " + _vm._s(_vm.eventProduct.product && _vm.eventProduct.product.skus[0] && _vm.eventProduct.product.skus[0].once_quantity) + " ")])], 2), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "下單數量遞增數",
      "label-for": "once_increase_quantity"
    }
  }, [_vm.isEdit ? [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "id": "once_increase_quantity",
      "type": "number",
      "readonly": ""
    },
    model: {
      value: _vm.form.once_increase_quantity,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "once_increase_quantity", $$v);
      },
      expression: "form.once_increase_quantity"
    }
  })] : _c('div', [_vm._v(" " + _vm._s(_vm.eventProduct.product && _vm.eventProduct.product.skus[0] && _vm.eventProduct.product.skus[0].once_increase_quantity) + " ")])], 2), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "團購分店",
      "label-for": ""
    }
  }, [_vm.eventProduct.target_branches ? _c('BranchesTable', {
    attrs: {
      "branches": _vm.eventProduct.target_branches
    }
  }) : _vm._e()], 1)], 1)])])]), _vm.isEdit ? _c('div', {
    staticClass: "text-center",
    staticStyle: {
      "margin-top": "80px"
    }
  }, [_c('div', {
    staticClass: "text-danger mb-2"
  }, [_vm._v(" 白名單設定修改，不影響準備中/ 已開團商品 ")]), _c('b-button', {
    attrs: {
      "variant": "success",
      "disabled": _vm.isSubmitting,
      "busy": _vm.isSubmitting
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm.isSubmitting ? _c('span', {
    staticClass: "spinner-border spinner-border-sm",
    attrs: {
      "role": "status",
      "aria-hidden": "true"
    }
  }) : _vm._e(), !_vm.isSubmitting ? _c('span', [_vm._v("確認修改")]) : _vm._e()])], 1) : _vm._e()])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }